/* eslint-disable camelcase */
import '@sass/showresult/showresult.scss';
import { EventDispatcher, bindIntersectionObserver, classList, copyToClipboard, deepCopy, documentReady, gebi, genUID, getTimeText, getUrlVarBase64, getUrlVars, hideElement, isEmptyObject, isMobileView, isNetworkError, l, last, lc, logEvent, qs, qsa, removeEmptyEntriesFromObject, setUrlParameter, showElement, slideDown, storedItemCreate, storedItemRead, tabTrappingHelper, urlParameterDelete, urlParameterGet, urlParameterSet } from '@utils/toolbox';
import { toaster } from '@js/components/toast';
import { dateGetDate, dateGetMonth, dateParseISO } from '@utils/dateFns';
import { eventCategories, events } from '@js/utils/event';
import { Base64 } from '@js/plugins/base64';
import { Civet } from '@js/plugins/civet';
import { DisplayDirector } from '@js/components/displayDirector';
import { DisplayMessage } from '@components/displaymessage';
import { Favorite } from '@js/components/favorite/favorite';
import { useFiltersComponent } from '@/src/vue/components/Filters/Filters';
// import { FiltersMobile } from '@/src/vue/components/Filters/FiltersMobile';
import { KalleBakom } from '@js/components/kallebakom';
import { PriceCalendar } from '@module/PriceCalendar/PriceCalendar';
import { PriceCutter } from '@module/PriceCutter/PriceCutter';
import { PriceWatcher } from '@module/PriceWatcher/PriceWatcher';
import { SearchBox } from '@module/SearchBox/SearchBox';
import { TooltipDialog } from '@js/components/tooltipDialog';
// import { Filters } from '@module/Filters/Filters';
import { resultsFetcher } from '@components/resultsFetcher';
import { resultsRender } from '@components/resultsRender';
import { timeline } from '@components/timeline';
import { timetable } from '@components/timetable';
import { trackEvent } from '@utils/googleDataLayer';
import { useFiltersStore } from '@/src/vue/components/Filters/store/filtersStore';
import { useResultQueryStore } from '@/src/vue/components/Filters/store/resultQueryStore';
import { renderJourneys } from '@js/components/resultsRenderTemplate';

const { urlVars, timestamp, sharedOrgIndex } = js_params;
const defaultSorting = urlVars?.sorting || js_params.defaultSorting;
/**
 * @typedef {Object} searchBoxData
 * @property {String} searchBoxData.departDate
 * @property {String} searchBoxData.from
 * @property {String} searchBoxData.fromIata
 * @property {Array} searchBoxData.fromIatas
 * @property {Boolean} searchBoxData.fromMetro
 * @property {String} searchBoxData.returnDate
 * @property {String} searchBoxData.to
 * @property {String} searchBoxData.toIata
 * @property {Array} searchBoxData.toIatas
 * @property {Boolean} searchBoxData.toMetro
 */

/**
 * @typedef {Object} flight
 * @property {Number} best
 * @property {Number} cabin
 * @property {Number} climateCompensationPrice
 * @property {String} climateCompensationUrl
 * @property {Number} compensated_emission
 * @property {Number} emission
 * @property {Number} lowestprice
 * @property {Number} orgIndex
 * @property {String} promotedAgent
 * @property {String} promotedProduct
 * @property {Number} raw_emission
 * @property {Number} traveltime
 * @property {Array} trips
 */

const showresult = {
	searchParams: {
		page: 0,
		id: urlVars.id,
		timestamp: timestamp,
		sorting: defaultSorting,
		filters: getUrlVarBase64('filter'),
		sharedOrgIndex: sharedOrgIndex,
		initial: true
	},
	previousSorting: defaultSorting,
	isMobile: isMobileView(),
	isYouthSearch: js_params?.isYouthSearch,
	elems: {
		header: qs('header'),
		footer: gebi('menu-sorting-footer'),
		sortBars: qsa('.abTabNav--sortResult [data-sort]'),
		searchBoxWrapper: gebi('ab-showresult-search-box'),
		resultsColumn: gebi('results-column'),
		scrollToTop: gebi('ab-scroll-to-top'),
		flexTicketCheckbox: qs('[data-filterkey="flexTicket"] input'),
		climateCheckbox: qs('input#include-climate-compensation'),
		resultsContainer: qs('#results-container'),
		resultsLoadFeedback: qs('#search-loader')
	},
	/**
	 * @type {KalleBakom}
	 */
	kalleBakom: null,
	/**
	 * @type {Favorite}
	 */
	favorite: null,
	/**
	 * @type {Filters}
	 */
	filters: null,
	/**
	 * @type {DisplayMessage}
	 */
	// displayMessage: null,
	/**
	 * @type {PriceCalendar}
	 */
	priceCalendar: null,
	/**
	 * @type {DisplayDirector}
	 */
	displayDirector: null,
	/**
	 * @type {PriceWatcher}
	 */
	priceWatcher: null,
	/**
	 * @type {PriceCutter}
	 */
	priceCutter: null,
	priceCutterMini: null,
	activeView: 'list',
	networkErrorCount: 0,

	/**
	 * @type {useFiltersStore}
	 */
	filtersStore: useFiltersStore(),

	resultQueryStore: useResultQueryStore(),

	async init () {
		this.getSavedFilters();
		this.setCarbonOffsetTabState(!!this.searchParams?.filters?.climateCompensated);
		resultsRender.init();
		this.initSearchBox();
		this.initFavorite();
		this.initEvents();
		this.setSortingTabs(this.searchParams.sorting);
		this.initFilters();


		// If invalid search then relax ^_^
		if (!this.isValidSearch() && !urlVars?.forceNearbyDates) {
			this.toggleLoader(false);
			return;
		}

		switch (js_params.isupdating) {
			case 0: // Search complete
				await this.resultsGetFirst();
				break;
			case 1: // Search on going
				// The promise chain is quite deep here, be careful not to break it
				// await searchBox.continueSearch ->  await searchBox._callbacks.onSearchComplete -> await showresult.resultsPrepareRequest > await showresult.resultsGetFirst > await showresult.resultsGet
				await this.searchBox.continueSearch(js_params);
				break;
			// case 2: // Search failed
			// Handled by this.isValidSearch()
		}

		this.displayDirector = new DisplayDirector();

		this.initPriceCutterMini();
		this.initPriceCalendar();
		this.initPriceCutter();
		this.initPriceWatcher();
		this.initIntersectionObserver();

		// track price warnings
		if (gebi('price-warning')) {
			if (gebi('price-warning').classList.contains('result-box-warning--too-old')) {
				logEvent(events.observeAncientSearch, eventCategories.observe);
			} else if (gebi('price-warning').classList.contains('result-box-warning--old')) {
				logEvent(events.observeOldSearch, eventCategories.observe);
			}
		}

		// Initialise Timeline and Timetable
		timeline.init();
		timetable.init();

		if (urlVars?.forceNearbyDates) {
			hideElement('#displayDirector [data-show="pricecutter"]');
			this.displayDirector.activateShowcase({ showcase: 'pricecalendar' });
		}

		if (urlVars?.debugKalle) {
			this.kalleBakomShow(0);
		}
		this.initWCAG();
	},

	searchParamsForAPI (searchParams = this.searchParams) {
		const searchParamsCopy = removeEmptyEntriesFromObject(deepCopy(searchParams));

		if (!resultsRender.isSharedResultView) {
			delete searchParamsCopy?.sharedOrgIndex;
		}

		// Remove front only params
		delete searchParamsCopy?.filters?.activeTimetableBtns;
		delete searchParamsCopy?.filters?.sortEmission;
		delete searchParamsCopy?.filters?.collapsed;

		// Do not send youthTicket filters when no youth ticket are available
		// TODO: when is it possible to get this to fire? Documentation/testing needed
		if (searchParamsCopy.filters?.youthTicket && !this.isYouthSearch) {
			delete searchParamsCopy.filters?.youthTicket;
		}

		return searchParamsCopy;
	},

	setPersisentFiltersToUrl (url) {
		const { filters } = this.searchParamsForAPI();

		const checkIfLegsHaveChangedSinceLanding = () => {
			// If the user has only changed the date the append the currently applied filters to the URL
			const currentLegsLength = this.searchBox.data.legs.length;
			const currentLegsData = this.searchBox.data.legs.map((leg) => {
				// remove the property 'origin' as it's not present on js_params.showresultSearchParams
				const fromIatasWithoutOrigin = leg.fromIatas.map(({ origin, ...rest }) => rest);
				const toIatasWithoutOrigin = leg.toIatas.map(({ origin, ...rest }) => rest);
				return JSON.stringify(fromIatasWithoutOrigin) + JSON.stringify(toIatasWithoutOrigin);
			}).join(',');
			const previousLegsLength = js_params.showresultSearchParams.length;
			const previousLegsData = js_params.showresultSearchParams.map(leg => JSON.stringify(leg.fromIatas) + JSON.stringify(leg.toIatas)).join(',');
			const isSame = currentLegsLength === previousLegsLength && currentLegsData === previousLegsData;
			return isSame;
		};

		if (filters && Object.keys(filters).length) {
			const isSame = checkIfLegsHaveChangedSinceLanding();

			// Update baggageIncluded to match the current number of passengers
			if (filters?.baggageIncluded) {
				filters.baggageIncluded = resultsRender.numberOfBags;
			}

			if (!isSame) {
				return url;
			}


			// If single trip, only send one departure and arrival time
			if (this.searchBox.data.tripType === 0) {
				if (filters?.departureTime?.length) {
					filters.departureTime = filters.departureTime.filter(departureTimeFilter => departureTimeFilter.tripIndex === 0);
				}
				if (filters?.arrivalTime?.length) {
					filters.arrivalTime = filters.arrivalTime.filter(arrivalTimeFilter => arrivalTimeFilter.tripIndex === 0);
				}
			}

			// If return trip, only send two departure and arrival times
			if (this.searchBox.data.tripType === 1) {
				if (filters?.departureTime?.length) {
					filters.departureTime = filters.departureTime.filter(departureTimeFilter => departureTimeFilter.tripIndex === 0 || departureTimeFilter.tripIndex === 1);
				}
				if (filters?.arrivalTime?.length) {
					filters.arrivalTime = filters.arrivalTime.filter(arrivalTimeFilter => arrivalTimeFilter.tripIndex === 0 || arrivalTimeFilter.tripIndex === 1);
				}
			}


			// if departureTime or arrivalTime is an empty array, remove it
			if (filters?.departureTime?.length === 0) {
				delete filters.departureTime;
			}

			if (filters?.arrivalTime?.length === 0) {
				delete filters.arrivalTime;
			}

			// remove airportStops
			// TODO: remove this when the API is fixed to use a whitelist instead of a blacklist
			delete filters.airportStops;

			if (filters && Object.keys(filters).length) {
				const filtersBase64 = encodeURIComponent(Base64.encode(JSON.stringify(filters)));
				url = setUrlParameter(url, 'filter', filtersBase64);
			}
		}
		return url;
	},

	resultsPrepareRequest () {
		// Request searchParameters from timetable or timeline
		if (document.body.classList.contains('timeline')) {
			EventDispatcher.dispatch('showresult:requestResultUpdate', { target: 'timeline' });
		} else if (document.body.classList.contains('timetable')) {
			EventDispatcher.dispatch('showresult:requestResultUpdate', { target: 'timetable' });
		} else {
			return this.resultsGetFirst();
		}
	},

	toggleLoader (show) {
		if (show) {
			this.elems.resultsLoadFeedback.addEventListener('transitionend', () => {
				hideElement(this.elems.resultsLoadFeedback);
			}, { once: true });
		} else {
			showElement(this.elems.resultsLoadFeedback);
		}
		this.elems.resultsLoadFeedback.classList.toggle('loading-results', show);
		this.elems.resultsLoadFeedback.classList.toggle('with-results', !show);
	},

	/**
	 * Resets searchParams.page to 0
	 * Saves searchParams.filters to localStorage
	 * Calls showresult_data.php
	 * Fades in and out the result container
	 * Shows no results message when appropriate
	 * @param {Object} searchParams
	 * @returns {Promise}
	 */
	async resultsGetFirst (searchParams = this.searchParamsForAPI()) {
		this.toggleLoader(true);
		// Generate a UID for this search for use in the resultsGet function
		this.requestId = genUID();

		this?.displayMessage?.hide?.();

		// Save filters to URL
		this.saveFiltersToUrl();

		// Set search page to 0
		searchParams.page = 0;
		this.searchParams.page = 0;

		resultsRender.response.flights = [];

		await this.resultsGet(searchParams, true);
		this.toggleLoader(false);

		if (resultsFetcher.isError) {
			return;
		}

		// Show warning messages if applicable
		if (this.isYouthSearch && !resultsRender.response?.meta?.hasYouthTickets) {
			this.showNoYouthTicketsWarning();
			this.resultsPrepareRequest();
			return;
		} else if (!resultsRender?.response?.meta?.resultCount) {
			this.showResetFiltersMsg();
		}

		this.resultQueryStore.set(resultsRender.response);

		delete this.searchParams.initial;

		// this.filters.renderFooter();
	},

	/**
	 * Calls showresult_data.php and merges the response with the previous response
	 * Emits event showresult:resultUpdate for timeline and timetable
	 * Updates sorting tab prices
	 * Renders no more results
	 * @param {Object} searchParams
	 * @returns {Promise}
	 */
	resultsGet (searchParams) {
		if (document.body.classList.contains('timetable') || document.body.classList.contains('timeline')) {
			this.requestId = genUID();
		}


		gebi('results-offline')?.remove?.();

		const currentRequestId = this.requestId;

		return resultsFetcher.get(searchParams).then((response) => {
			// If the request ID has changed then abort setting data and rendering
			if (currentRequestId !== this.requestId) {
				return;
			}
			// Sucessfull network request! Lets reset networkErrorCount
			this.networkErrorCount = 0;

			const responseMerged = {
				...resultsRender.response,
				...response,
				trips: {
					...resultsRender.response?.trips,
					...response?.trips
				},
				segments: {
					...resultsRender.response?.segments,
					...response?.segments
				},
				airportDetails: {
					...resultsRender.response?.airportDetails,
					...response?.airportDetails
				},
				flights: [
					...resultsRender.response?.flights || [],
					...response?.flights || []
				]
			};

			resultsRender.setData(responseMerged, searchParams);

			if (!document.body.classList.contains('timetable') && !document.body.classList.contains('timeline')) {
				// Render the new results
				resultsRender.render(response.flights, searchParams.page, this.elems.resultsContainer, 'list');
			}

			// Render timeline or timetable
			this.emitResponseChanged(response.flights);

			// Render sorting tabs
			if (!document.body.classList.contains('timetable')) {
				this.updateSortingTabs();
			}

			// Show no more results
			if (searchParams.page === resultsRender?.response?.meta?.numberOfPages) {
				this.renderNoMoreResults();
			}
		}).catch(this.resultsError.bind(this));
	},

	/**
	 *
	 * @returns
	 */
	async resultsGetNext (isForce = false) {
		const notListView = document.body.classList.contains('timetable') || document.body.classList.contains('timeline');
		const isLoading = resultsFetcher.isLoading;
		const isError = resultsFetcher.isError;

		if (!isForce && (notListView || isLoading || isError)) {
			return;
		}
		this.searchParams.page += 1;
		const response = await this.resultsGet(this.searchParamsForAPI());
		if (resultsFetcher.isError) {
			this.searchParams.page -= 1;
		}
		return response;
	},

	/**
	 *
	 * @param {Object} data
	 * @returns
	 */
	resultsError (data) {
		console.log('resultsError', data);
		this.toggleLoader(false);
		// don't display error message if the request was aborted
		if (data?.statusText === 'abort') {
			return;
		}

		this.elems.resultsContainer.classList.remove('loading-results');
		this.elems.resultsContainer.classList.add('with-results');

		let activeView = 'list';

		if (document.body.classList.contains('timetable')) {
			activeView = 'timetable';
		} else if (document.body.classList.contains('timeline')) {
			activeView = 'timeline';
		}

		// Update Timeline and Timetable views
		EventDispatcher.dispatch('showresult:requestResultUpdateError', { target: activeView });

		this.updateSortingTabs();

		// default to e9 if no message was passed, if backend replied with 'no data' then use error.searchTooOld
		let messageText = data?.error ? data.error : l('error.e9');
		if (data?.error === 'no data') {
			messageText = l('error.searchTooOld');
		}

		let displayMessage = { messageText: messageText };

		const _isNetworkError = isNetworkError(data);

		if (_isNetworkError) {
			// Set a fixed error message on network errors
			data.message = 'Failed to fetch: showresult_data.php\n' + data.message;

			if (activeView === 'list' && this.searchParams.page > 0 && resultsRender.response?.flights?.length) {
				this.offlineFooterRender();
			} else {
				displayMessage = { messageText: l('error.e14'), buttonText: l('global.simplePhrases.tryAgain'), callBack: () => window.location.reload() };
				this.showDisplayMessage(displayMessage);
			}
			this.networkErrorCount += 1;
		} else {
			// Show deleted result list, invalid list error or network error message
			this.showDisplayMessage(displayMessage);
		}

		// This isn't a backend or a network issue but rather something that has gone wrong with the rendering logic so let's inform civet
		if (!('error' in data)) {
			Civet.reportError(data);
		}

		console.log('Error in resultsGet', data);
	},

	initFilters () {
		this.resultQueryStore.set(resultsRender.response);

		const filtersFromUrl = getUrlVarBase64('filter');

		if (!isEmptyObject(filtersFromUrl)) {
			this.filtersStore.setAll(filtersFromUrl, false);
			this.searchParams.filters = filtersFromUrl;
		} else {
			this.searchParams.filters = this.filtersStore.get.value;
		}

		const filtersDesktop = useFiltersComponent(false);
		const FiltersMobile = useFiltersComponent(true);

		filtersDesktop.mount('#filters-column');
		FiltersMobile.mount('#filters-mobile');

		// Watch for changes to climateCompensated and update the checkbox
		watch(() => this.filtersStore.state.climateCompensated, (newValue) => {
			qs('input#include-climate-compensation').checked = newValue;
		});


		// Sync filters with the filters store
		watch(this.filtersStore.get, async (newFilters) => {
			this.searchParams.filters = newFilters;

			await this.resultsPrepareRequest();

			// Update Price Calendar if available
			this.priceCalendar?.setFilters?.(this.searchParams.filters);

			this.scrollToTopOfResults();
		});
	},

	scrollToTopOfResults () {
		if (!this.isMobile && this.displayDirector?.showcase) {
			const elementToScrollTo = qs('.showresultTop');

			if (elementToScrollTo) {
				const offset = 5;
				const top = elementToScrollTo.getBoundingClientRect().top + window.scrollY - offset;

				window.scrollTo({ top });
			}
			return;
		}

		if (window.scrollY > 0) {
			const elementToScrollTo = this.isMobile
				? qs('.abResult[data-index="0"]')
				: qs('.abTabNav--sortResult');

			if (elementToScrollTo) {
				const offset = this.isMobile ? 142 : 10;
				const top = elementToScrollTo.getBoundingClientRect().top + window.scrollY - offset;

				window.scrollTo({ top });
			}
		}
	},

	initWCAG () {
		qsa('.filtersView').forEach((filter) => {
			filter.querySelectorAll('a, button, label, input, textarea, select, .noUi-handle').forEach((elem) => {
				elem.tabIndex = -1;
			});

			if (isMobileView()) {
				filter.tabIndex = -1;
			}
		});

		gebi('ab-showresult-search-box').querySelectorAll('a, button, label, input, textarea, select, .noUi-handle, .abSearchBox__depart, .abSearchBox__return, .abSearchBox__passengers').forEach((elem) => {
			elem.tabIndex = -1;
		});

		if (isMobileView()) {
			qsa('.abSearchBox__cabin, .abShowResultSearchBox, #filters-column, .abBtn--resetFilters, .abBtn--hideFilters').forEach((elem) => {
				elem.tabIndex = -1;
			});
		}
	},

	initFavorite () {
		// show favs number on load
		if (!this.favorite) {
			this.favorite = new Favorite();
		}

		this.updateFavBtns();
	},

	updateFavBtns () {
		const goToFavBtns = qsa('[data-action="goToFav"]');

		if (this.favorite.favouriteArray.length > 0) {
			goToFavBtns.forEach((favBtn) => {
				favBtn.dataset.amount = this.favorite.favouriteArray.length;
				favBtn.dataset.fill = true;
			});
		} else {
			goToFavBtns.forEach((favBtn) => {
				delete favBtn.removeAttribute('data-amount');
				delete favBtn.removeAttribute('data-fill');
			});
		}
	},

	kalleBakomShow (index, resultIsPriceCalendar = false) {
		const isListOrTimetable = !document.body.classList.contains('timeline');
		const isReturnTrip = resultsRender.response?.meta?.tripType === 1;
		const isMultiCitySearch = resultsRender.response?.meta?.tripType === 2;

		if (!isListOrTimetable || resultIsPriceCalendar || isMultiCitySearch) {
			return;
		}

		let flight = resultsRender.response?.flights?.[index];

		if (js_params?.urlVars?.forceNearbyDates) {
			flight = this.priceCalendar.activeResult;
		}

		const trip = resultsRender.getTripsAndSegmentsForFlight(flight);
		const outboundSegments = trip?.[0]?.segments;
		if (!outboundSegments) {
			return;
		}

		const { departureAirport } = outboundSegments[0];
		const { arrivalAirport, arrivalDate: pickupDateTime } = last(outboundSegments);

		const inboundSegments = last(trip).segments[0];
		const { departureDate: returnDateTime } = inboundSegments;

		if (!this.kalleBakom) {
			this.kalleBakom = KalleBakom();
		}

		this.kalleBakom.display({
			airportInformation: resultsRender.getAirport(arrivalAirport),
			kallebakomRequest: [arrivalAirport, departureAirport, isReturnTrip, pickupDateTime, returnDateTime, js_params.passengers, js_params?.childrenAges || [], js_params?.youthAges || []]
		});
	},

	/**
	 *
	 * @returns {Boolean}
	 */
	isValidSearch () {
		const { departureDateIsInThePast, searchIsDeleted, isupdating } = js_params;

		const searchFailed = isupdating === 2;

		if (departureDateIsInThePast || searchIsDeleted || searchFailed) {
			const config = {
				style: 'showResult',
				buttonText: l('global.simplePhrases.back'),
				callBack: () => (location.href = '/')
			};

			if (searchFailed) {
				config.messageText = l('error.e8');
			} else if (searchIsDeleted) {
				config.messageText = l('showresult.message.deletedWarning');
			} else if (departureDateIsInThePast) {
				config.messageText = l('error.searchTooOld');
				config.buttonText = l('searchBox.search.searchBtnText');
				config.callBack = () => this.showSearchBoxExtended();
			}

			this.showDisplayMessage(config);

			return false;
		}

		return true;
	},


	getSavedFilters () {
		const savedFilters = storedItemRead('savedFilters') || {};

		// Remove arrival time, departure time and airport stops from saved filters because
		// they may not be relevant to this search result
		delete savedFilters.arrivalTime;
		delete savedFilters.departureTime;
		delete savedFilters.airportStops;
		delete savedFilters.traveltime;

		// Merge URL filters and filters from localStorage
		const mergedFilters = { ...savedFilters, ...this.searchParams.filters };


		storedItemCreate('savedFilters', mergedFilters);
	},

	initPriceCutter () {
		if (!js_params?.isPriceCutterEnabled) {
			return;
		}

		if (js_params?.disablePriceCutter === true) {
			qsa('[data-showcase="pricecutter"]').forEach(pricecutterEnabler => pricecutterEnabler.classList.add('disabled'));
			return;
		}
		const searchData = {
			fromIata: js_params.from.iata,
			toIata: js_params.to.iata,
			departDate: js_params.leavedate,
			returnDate: js_params.homedate,
			returnTrip: js_params.returntrip,
			adults: js_params.adults,
			childrenAges: js_params.childrenAges,
			price: js_params.price,
			responseId: js_params.id
		};

		this.priceCutter = new PriceCutter({ searchData, container: qs('.abPriceCutter', this.displayDirector.elements.displayDirector) });
		// this.displayDirector.activateShowcase({ showcase: 'pricecutter' });
	},

	initPriceCutterMini () {
		if (!js_params?.isPriceCutterEnabled) {
			return;
		}
		const searchData = {
			fromIata: js_params.from.iata,
			toIata: js_params.to.iata,
			departDate: js_params.leavedate,
			returnDate: js_params.homedate,
			returnTrip: js_params.returntrip,
			adults: js_params.adults,
			childrenAges: js_params.childrenAges,
			price: js_params.price,
			responseId: js_params.id
		};

		this.priceCutterMini = new PriceCutter({ searchData, container: qs('#pricecutter-mini'), isMini: true });
	},

	initPriceCalendar () {
		// return;
		if (!js_params.isPriceCalendarEnabled) {
			return;
		}

		const searchNearby = urlParameterGet('nearbyDates');
		const nearbyDates = parseInt(searchNearby, 10) === 1;

		this.priceCalendar = new PriceCalendar(gebi('ab-price-calendar'), nearbyDates, this.searchParams.sorting, this.searchParams.filters);

		if (nearbyDates && !isMobileView()) {
			this.displayDirector.activateShowcase({ showcase: 'pricecalendar' });
		}

		// qs(`.chipMenu--otherDates`).dataset.status = 'process';
	},

	initPriceWatcher () {
		this.priceWatcher = PriceWatcher.init();
	},

	initSearchBox () {
		const urlFilters = getUrlVarBase64('filter');

		let nearbyDates = 0;
		let direct = (urlFilters?.numStops === 0) || 0;
		let baggage = urlFilters?.baggageIncluded || 0;
		let cabinBaggage = urlFilters?.cabinBaggageIncluded || 0;
		let climateComp = urlFilters?.climateCompensated || 0;
		let flexTicket = urlFilters?.flexTicket || 0;

		const userSavedSearch = storedItemRead('userSavedSearch');

		if (userSavedSearch) {
			direct = parseInt(userSavedSearch.direct, 10);
			baggage = parseInt(userSavedSearch.baggage, 10);
			cabinBaggage = parseInt(userSavedSearch.cabinBaggage, 10);
			nearbyDates = parseInt(userSavedSearch.nearbyDates, 10);
			climateComp = parseInt(userSavedSearch.climateComp, 10);
			flexTicket = parseInt(userSavedSearch.flexTicket, 10);
		}

		const searchboxConfig = {
			direct: direct,
			baggage: baggage,
			cabinBaggage: cabinBaggage,
			nearbyDates: nearbyDates,
			climateComp: climateComp,
			flexTicket: flexTicket
		};

		// If the result exists, add legs, cabin ( => ticket class) and trip type
		// Else, let SearchBox module fall back to default
		if (js_params.id !== '') {
			const cabin = parseInt(js_params.classType, 10);
			const legs = JSON.parse(JSON.stringify(js_params.showresultSearchParams));

			searchboxConfig.legs = legs;
			searchboxConfig.cabin = cabin;
			searchboxConfig.tripType = js_params.returntrip;
		}

		// Format passenger data
		const selectedPassengersView = this.isYouthSearch ? 'youth' : 'default';
		if (selectedPassengersView === 'default') {
			searchboxConfig.passengers = {
				adults: js_params.adults,
				child: {
					count: js_params.childrenAges.length,
					ages: js_params.childrenAges
				}
			};
		} else {
			searchboxConfig.passengers = {
				youth: {
					count: js_params?.youthAges?.length || js_params.passengers,
					ages: js_params?.youthAges || []
				}
			};
		}

		this.searchBox = new SearchBox({
			id: 'abSearchBox',
			calendarRender: gebi('abSearchbox__dates'),
			showresultMode: true,
			selectedPassengersView: selectedPassengersView,
			config: searchboxConfig,
			callbacks: {
				// This function can be called in two cases:
				// 1. On initial page load (showresult)
				// 2. When the user clicks the search button
				onPreviewReceived: (instance, previewGroup) => {
					if (this.searchParams.initial) {
						if (previewGroup?.flights?.length) {
							this.setupPreviewResultsTimeout(500);
							this.generateTempResult(previewGroup);
						}
					} else {
						instance.cancelSearch();

						instance.showresultURL = this.setPersisentFiltersToUrl(instance.showresultURL);

						location.href = instance.showresultURL;
					}
				},
				onSearchComplete: async (instance) => {
					/**
					 * This is to prevent a specific bug where there is only one OTA replying but they reply last.
					 * So we go from status searching to complete with no preview in-between.
					 */
					const { id } = getUrlVars(instance.showresultURL);

					// This function will check if the legs are the same, if the legs have not changed we will append the filters to the url
					instance.showresultURL = this.setPersisentFiltersToUrl(instance.showresultURL);

					if (instance.data.forceNearbyDates) {
						instance.showresultURL = setUrlParameter(instance.showresultURL, 'forceNearbyDates', 1);
					}

					if (!instance.resultCount || this.searchParams.id !== id) {
						location.href = instance.showresultURL;
						return;
					}

					document.body.classList.remove('search-loading');

					this.clearPreviewResultsInterval();
					await this.resultsPrepareRequest();

					// If nearby dates is selected or we haven't shown the animation yet, show it
					if (nearbyDates || !storedItemRead('animatePriceHunterHero')) {
						storedItemCreate('animatePriceHunterHero', 1);
					}
				},
				onSearchError: (instance) => {
					// if nearbyDates is not set then show a modal asking the user if they want to search nearby dates
					if (!nearbyDates) {
						location.href = `${instance.showresultURL}&showNearbyDatesModal=1`;
					} else {
						document.body.classList.remove('search-loading');
					}
				}
			}
		});

		this.setHeaderFromToDates(this.searchBox.data.tripType, this.searchBox.data.legs);
	},

	initEvents () {
		const { searchBoxWrapper } = this.elems;
		const searchBoxInner = qs('.abShowResultSearchBox__inner', searchBoxWrapper);


		// This component is responsible for the sticky header and footer on mobile
		this.mobileFooterController = new MobileFooterController({
			footer: this.elems.footer,
			header: this.elems.header,
			scrollToTop: document.querySelector('.abScrollToTop')
		});

		let startTouchPos = 0;
		let stopYPos = 0;
		let moveYDist = 0;


		document.addEventListener('click', (event) => {
			const elem = event.target;

			// Add to favorites
			if (elem.closest('.abResult__flightFavBtn')) {
				event.stopPropagation();

				const addFavorite = () => {
					const flightIndex = elem.closest('[data-index]').getAttribute('data-index');
					const flight = resultsRender.getFlightRenderData(resultsRender.response.flights[flightIndex], flightIndex, 'list');

					if (elem.closest('.abResult__flightFavBtn').classList.contains('favorited')) {
						elem.closest('.abResult__flightFavBtn').classList.remove('favorited');
						const favouriteUid = this.favorite.itemGenerateUid(js_params.id, flight.orgIndex, flight.agents[0].urlOptions);
						const favouriteIndex = this.favorite.itemGetIndexByUid(favouriteUid);
						this.favorite.itemRemoveByIndex(favouriteIndex, false);
						logEvent(events.removeFavourite, eventCategories.feature, flight.hashes);
					} else {
						elem.closest('.abResult__flightFavBtn').classList.add('favorited');
						this.favorite.itemCreate(
							js_params.id,
							flight.orgIndex,
							this.searchParams.filters,
							flight.hashes,
							flight.agents[0].urlOptions
						);
						logEvent(events.addFavourite, eventCategories.feature, flight.hashes);
					}

					this.updateFavBtns();
				};

				if (window?.Main?.cookieNotice && !window?.Main?.cookieNotice?.isFunctionalCookiesSet) {
					EventDispatcher.dispatch('cookieNotice:blockingModal:show');
					EventDispatcher.addEventListener('cookieNotice:blockingModal:accept', () => {
						addFavorite();
					});
					return;
				} else {
					addFavorite();
				}

				return;
			}

			if (elem.classList.contains('otaLink') && js_params.searchDateIsTooOld) {
				event.preventDefault();
				return;
			}

			if (js_params.kalleBakomEnabled && elem.classList.contains('otaLink')) {
				const resultIsPriceCalendar = elem.closest('#priceCalendarResultModal');

				this.kalleBakomShow(elem.closest('.abResult').dataset.index, resultIsPriceCalendar);

				return;
			}

			// Search box hide
			if (elem.closest('[data-action="hide-search-box"]') || (elem.classList.contains('abShowResultSearchBox__inner') && isMobileView())) {
				// EventDispatcher.dispatch('searchBoxReset');
				this.hideSearchBoxExtended(200);
				return;
			}

			// Search box show
			if (elem.closest('[data-action="show-search-box"]')) {
				this.showSearchBoxExtended();
			}

			// Enable toggle mode
			if (elem.closest('[data-action="goToFav"]')) {
				if (this.favorite.favouriteArray.length) {
					window.location = this.favorite.pageUrl;
				} else {
					toaster.newToast(l('fav.ui.noFavs'), 'info', 'stays');
				}
			}

			// Sorting tabs
			if (elem.closest('.abTabNav--sortResult .sort-type')) {
				const clickedSortingType = elem.dataset.sort;

				if (clickedSortingType === 'emission') {
					const filtersStore = useFiltersStore();
					filtersStore.set({ key: 'climateCompensated', value: this.searchParams?.filters?.climateCompensated ? null : true });
					this.setCarbonOffsetTabState(!this.searchParams?.filters?.climateCompensated);
					return;
				}
				this.updateSorting(clickedSortingType);
				return;
			}

			// Price calendar sorting radio buttons
			if (elem.closest('.priceCalendarSorting input[type=radio]')) {
				this.updateSorting(elem.value);
				return;
			}

			// Scroll to top button
			if (elem.closest('#ab-scroll-to-top')) {
				event.stopPropagation();

				const scrollToTop = elem.closest('#ab-scroll-to-top');

				scrollToTop.classList.remove('abScrollToTop--visible');

				window.scrollTo({ top: 0, behavior: 'smooth' });

				return;
			}

			// Tabs in kallebakom
			if (elem.hasAttribute('data-kalletab')) {
				if (!elem.classList.contains('active')) {
					const oldAtribute = qs('.active[data-kalletab]').getAttribute('data-kalletab');

					// Toggle visible option
					classList('.active[data-kalletab]').remove('active');
					classList('.active[data-kalleview]').remove('active');
					elem.classList.add('active');

					gebi('kallebakomModal').classList.remove(oldAtribute);

					const newTab = '[data-kalleview="' + elem.getAttribute('data-kalletab') + '"]';
					classList(newTab).add('active');
					gebi('kallebakomModal').classList.add(elem.getAttribute('data-kalletab'));

					// Change url and text of modal button
					const newUrl = qs(newTab + ' .kallebakom_cta').getAttribute('data-url');
					const newKalleid = qs(newTab + ' .kallebakom_cta').getAttribute('data-kalleid');
					const newText = qs(newTab + ' .kallebakom_cta').innerHTML;
					qs('.kallebakom .kallebakom_maincta').setAttribute('data-url', newUrl);
					qs('.kallebakom .kallebakom_maincta').setAttribute('data-kalleid', newKalleid);
					qs('.kallebakom .kallebakom_maincta').innerHTML = newText;
				}
			}

			// Old search result warning
			if (elem.closest('#closeBestSortingInfo')) {
				event.stopPropagation();

				// Remove from the dom
				qs('#bestSortingInfo').remove();
				document.body.classList.remove('warningBest');

				logEvent(events.readmoreBestSorting, eventCategories.readmore);

				return false;
			}

			if (elem.closest('#bestSortingInfo')) {
				event.stopPropagation();

				const warningDialog = new TooltipDialog(l('showresult.dialogTooltip.bestFunctionTitle'), l('showresult.dialogTooltip.bestFunctionText'), () => { }, { singleButton: true }, [], elem.closest('#bestSortingInfo').dataset.readmore);

				warningDialog.show();
			}


			if (elem.closest('[data-action="copyDiscount')) {
				copyToClipboard(elem.closest('.discountBox').querySelector('input').value).then(() => {
					toaster.newToast(l('kallebakom.forex.clipboard'), 'info', 'top');
				});
			}

			// Old search result warning "update prices" link
			if (elem.id === 'update-current-prices') {
				event.preventDefault();

				logEvent(events.refreshsearch, eventCategories.search, eventCategories.search);

				qs('#ab-showresult-search-box button[data-action="search"]').click();
			}
		},
		false
		);

		document.addEventListener('touchstart', (event) => {
			const elem = event.target;

			if (elem.closest('.abSearchBox__menu')) {
				return;
			}

			if (elem.closest('.abShowResultSearchBox__inner')) {
				if (this.allowSearchBoxTouchMove()) {
					searchBoxInner.classList.add('abShowResultSearchBox__inner--touch');
					startTouchPos = event.touches[0].clientY;
				}
			}
		},
		{ passive: false }
		);

		document.addEventListener('touchmove', (event) => {
			const elem = event.target;

			if (this.searchBox.html.classList.contains('abSearchBox--show-overlay')) {
				return;
			}

			if (elem.closest('.abHeader')) {
				if (typeof event.cancelable !== 'boolean' || event.cancelable) {
					event.preventDefault();
				}

				return;
			}

			if (elem.closest('.abShowResultSearchBox__inner') || elem.closest('.abShowResultSearchBox__overlay')) {
				if (this.allowSearchBoxTouchMove()) {
					event.stopPropagation();

					const distance = event.touches[0].clientY - startTouchPos;
					const height = searchBoxInner.offsetHeight - this.elems.searchBoxWrapper.scrollTop;

					if (distance < 0) {
						if (height <= window.innerHeight) {
							if (typeof event.cancelable !== 'boolean' || event.cancelable) {
								event.preventDefault();
							}

							event.stopPropagation();

							stopYPos = event.touches[0].clientY;
							moveYDist = stopYPos - startTouchPos;

							searchBoxInner.style.transform = `translate3d(0, ${distance}px, 0)`;
						}
					}
				}

				return;
			}

			if (elem.closest('.abShowResultSearchBox__overlay')) {
				if (typeof event.cancelable !== 'boolean' || event.cancelable) {
					event.preventDefault();
				}
			}
		},
		{ passive: false }
		);

		document.addEventListener('touchend', (event) => {
			const elem = event.target;

			if (elem.closest('.abShowResultSearchBox__inner')) {
				event.stopPropagation();

				if (this.allowSearchBoxTouchMove()) {
					if (moveYDist < -120) {
						startTouchPos = 0;
						stopYPos = 0;
						moveYDist = 0;

						searchBoxInner.classList.remove('abShowResultSearchBox__inner--touch');
						searchBoxInner.style.transform = 'translate3d(0, -100%, 0)';

						setTimeout(() => {
							searchBoxWrapper.classList.remove('abShowResultSearchBox--visible');
							document.body.classList.remove('no-scroll');
							searchBoxInner.removeAttribute('style');
							document.body.style.position = '';
						}, 400);
					} else {
						searchBoxInner.classList.remove('abShowResultSearchBox__inner--touch');
						searchBoxInner.removeAttribute('style');
					}
				}
			}
		});

		// Special keyboard situations for show result page
		document.body.addEventListener('keyup', (event) => {
			if (event.key === 'Enter' || event.key === 'Space') {
				if (event.target.classList.contains('abResult')) {
					if (isMobileView()) {
						event.target.click();
						tabTrappingHelper(gebi('resultModal'), 'Result', () => qs('.js-close-modal').click());
					} else {
						if (!event.target.classList.contains('abResult--expanded')) {
							event.target.click();
							tabTrappingHelper(event.target, 'Result', () => event.target.click(), false, false);
							return;
						}
					}
				}

				if (event.target.classList.contains('sort-type')) {
					event.target.click();
					return;
				}

				if (event.target.classList.contains('abToggleSwitch')) {
					event.target.click();
					return;
				}

				if (isMobileView()) {
					if (event.target.classList.contains('abHeader__btn--searchData')) {
						const container = gebi('abSearchBox');
						tabTrappingHelper(container, 'Searchbox', () => this.hideSearchBoxExtended(), false, qsa('.abSearchBox__navBtn, .SearchFieldMulti__field, .abSearchBox__depart, .abSearchBox__return, .abSearchBox__passengers, .abSearchBox__cabin, .abSearchBox__view, .abSearchBox__checkbox > .checkbox, .abToggleSwitch, .abSearchBox__searchBtn', container), false);
					} else if (event.target.id === 'filters-mobile') {
						tabTrappingHelper(event.target, event.target.ariaLabel?.replace(/\s+/g, '-').toLowerCase(), false, false, qsa('.filtersChip', event.target));
					}
				} else {
					if (event.target.classList.contains('abShowResultSearchBox')) {
						const container = gebi('abSearchBox');

						if (!searchBoxWrapper.classList.contains('abShowResultSearchBox--visible')) {
							this.showSearchBoxExtended();
						}

						tabTrappingHelper(container, 'Searchbox', () => this.hideSearchBoxExtended(), false, qsa('.SearchFieldMulti__field, .abSearchBox__depart, .abSearchBox__return, .abSearchBox__passengers, .abSearchBox__cabin, .abSearchBox__view, .abSearchBox__checkbox > .checkbox, .abSearchBox__searchBtn', container), false);
						return;
					}

					if (event.target.classList.contains('filters-column')) {
						const container = gebi('filters-column');
						tabTrappingHelper(container, 'Filter-list', false, false, qsa('.filtersView', container));
						return;
					}

					if (event.target.classList.contains('filtersView')) {
						tabTrappingHelper(event.target, event.target.ariaLabel?.replace(/\s+/g, '-').toLowerCase(), false, false, qsa('a, button, input:not([type="checkbox"]), .checkbox, textarea, select, .noUi-handle, .abToggleSwitch', event.target));
					}
				}
			}
		});

		EventDispatcher.addEventListener('searchBox.searchError', (error) => {
			this.clearPreviewResultsInterval();
			hideElement(this.elems.resultsContainer);
			this.resultsError(error);
			this.hideSearchBoxExtended();
		});

		EventDispatcher.addEventListener('updateResultsSorting', (updatedSorting) => {
			// Handle reset sorting from filter modules (e.g. emission)
			// Fallback to the previous sorting selected by user if distinct, else fall back to default sorting (= price)
			if (!updatedSorting) {
				updatedSorting = (this.previousSorting !== this.searchParams.sorting) ? this.previousSorting : defaultSorting;
			}
			this.updateSorting(updatedSorting);
		});

		// Timetable and timeline merge search params
		EventDispatcher.addEventListener('updateResults', ({ source, params } = {}) => {
			const searchParams = this.searchParamsForAPI({
				...params,
				sorting: this.searchParams.sorting,
				page: 0,
				id: urlVars.id,
				timestamp: timestamp,
				// Carefully merge filters
				filters: {
					...this.searchParams.filters,
					...params.filters
				}
			});

			this.resultsGetFirst(searchParams);
		});

		EventDispatcher.addEventListener('displayDirector:display', this.setListView.bind(this));

		EventDispatcher.addEventListener('displayDirector:showcase:open', this.displayShowcase.bind(this));
		EventDispatcher.addEventListener('displayDirector:showcase:close', this.hideShowcase.bind(this));
	},
	hideShowcase (ev) {
		const { showcase } = ev;

		switch (showcase) {
			case 'pricecutter':
				this.priceCutter?.close();
				break;
			case 'pricecalendar':
				this.priceCalendar?.close();
				break;
			case 'pricewatcher':
				this.priceWatcher?.close();
				break;
			default:
				break;
		}
	},

	displayShowcase (ev) {
		const { showcase } = ev;

		switch (showcase) {
			case 'pricecutter':
				this.priceCutter?.load();
				this.priceCalendar?.close();
				this.priceWatcher?.close();
				break;
			case 'pricecalendar':
				this.priceCalendar?.open?.();
				this.priceCutter?.close();
				this.priceWatcher?.close();
				break;
			case 'pricewatcher':
				this.priceWatcher?.open?.();
				this.priceCutter?.close();
				this.priceCalendar?.close();
				break;
			default:
				break;
		}
	},


	initIntersectionObserver () {
		bindIntersectionObserver(gebi('results-intersection-observer'), (entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !resultsFetcher.isLoading && this.searchParams.page < resultsRender?.response?.meta?.numberOfPages) {
					this.resultsGetNext();
					logEvent(events.scrollMoreResults, eventCategories.scroll);
				}
			});
		}, { root: null, rootMargin: '30%', threshold: 0.1 });
	},

	trackSearchEvent () {
		const sc_children = js_params.childrenAges.length;
		const sc_adults = js_params.adults;
		const sc_from = js_params.from.city;
		const sc_to = js_params.to.city;
		const sc_roundtrip = js_params.returntrip;
		const sc_leave = js_params.leavedate;
		let sc_home;
		if (sc_roundtrip > 0) {
			sc_home = js_params.homedate;
		}

		const sc_price = js_params.price;
		const sc_id = js_params.fbid;
		const sc_fromData = js_params.from;
		const sc_toData = js_params.to;
		const sc_tripData = [{ from: sc_fromData, to: sc_toData }];

		trackEvent.searchInfo(sc_children, sc_adults, sc_from, sc_to, sc_leave, sc_home, sc_id, sc_price, sc_tripData);
		trackEvent.searchCompleted();
	},

	/**
	 * @param {Object} config
	 * @param {string} [config.style = showResult]
	 * @param {string} [config.messageText = error.e9]
	 * @param {string} [config.buttonText = searchBox.search.searchBtnText]
	 * @param {Function} [config.callBack = this.showSearchBoxExtended]
	 */
	showDisplayMessage (config = {}) {
		config = {
			style: 'showResult',
			messageText: l('error.e9'),
			buttonText: l('searchBox.search.searchBtnText'),
			callBack: () => this.showSearchBoxExtended(),
			...config
		};
		if (typeof this.displayMessage === 'undefined') {
			this.displayMessage = new DisplayMessage(this.elems.resultsColumn, config);
			this.displayMessage.show();
		} else {
			this.displayMessage.update(config);
			this.displayMessage.show();
		}

		logEvent(events.observeNoResults, eventCategories.observe, config.messageText ? config.messageText : config);
	},

	saveFiltersToUrl () {
		// Filters
		const filters = deepCopy(this.searchParams.filters);
		delete filters.alternativeHashes;

		if (!isEmptyObject(filters)) {
			urlParameterSet('filter', Base64.encode(JSON.stringify(filters)));
		} else {
			urlParameterDelete('filter');
		}
	},

	/**
	 * Dispatches showresult:resultsUpdated. Additionally calls priceCalender.update
	 * @param {flight[]} flightsData
	 */
	emitResponseChanged (flightsData) {
		// Send the word out that new results have been fetched to timetable and timeline

		EventDispatcher.dispatch('showresult:resultsUpdated', flightsData);
	},

	setListView (ev) {
		if (ev?.display === 'list') {
			this.resultsGetFirst();
		}
	},

	/**
	 * @param {Boolean} state
	 */
	setCarbonOffsetTabState (state) {
		qsa('.abTabNav__btn.sort-type[data-sort=emission] input').forEach((emissionTabNavInput) => {
			emissionTabNavInput.checked = state;
		});

		if (qs('.abTabNav__btn.sort-type.active')) {
			if (state) {
				logEvent(events.filterCO2CompensateEnabled, eventCategories.filter);
			} else {
				logEvent(events.filterCO2CompensateDisabled, eventCategories.filter);
			}
		}
	},

	/**
	 * @param {string} sort
	 */
	updateSorting (sort) {
		if (sort === this.searchParams.sorting) {
			return;
		}

		this.previousSorting = this.searchParams.sorting;

		this.searchParams.sorting = sort;
		// Update the url
		urlParameterSet('sorting', this.searchParams.sorting);

		// Update the price calendar
		this.priceCalendar?.setSorting?.(this.searchParams.sorting);

		// Update the nav tab
		this.setSortingTabs(sort);

		// Toggle the best sorting info depending on the isBestSorting state
		const isBestSorting = sort === 'bestValue';
		showElement('#bestSortingInfo', isBestSorting);
		document.body.classList.toggle('warningBest', isBestSorting && qs('#bestSortingInfo') !== null);

		this.scrollToTopOfResults();

		EventDispatcher.dispatch('updateFiltersSorting', sort);

		if (!document.body.classList.contains('timetable')) {
			this.resultsGetFirst();
		}

		qs('.abTabNav--sortResult').dataset.sort = sort;
	},

	showSearchBoxExtended () {
		window.scrollTo(0, 0);

		this.elems.searchBoxWrapper.classList.add('abShowResultSearchBox--visible');

		document.body.classList.add('no-scroll');

		if (!this.searchBox.html.classList.contains('abSearchBox--extended') && window.aboutToSearch !== 1) {
			logEvent(events.focusSearch, eventCategories.search);
		}

		this.searchBox.html.classList.add('abSearchBox--extended');
		this.blurAbBtnCards();

		if (document.body.style.position !== 'fixed') {
			document.body.style.position = 'fixed';
		}
	},

	/**
	 * @param {Number} timeout
	 */
	hideSearchBoxExtended (timeout = 0) {
		const inner = this.elems.searchBoxWrapper.querySelector('.abShowResultSearchBox__inner');
		inner.classList.remove('abShowResultSearchBox__inner--touch');
		inner.classList.add('abShowResultSearchBox__inner--slideUp');

		setTimeout(() => {
			const scrollY = document.body.style.top;
			this.elems.searchBoxWrapper.classList.remove('abShowResultSearchBox--visible');
			document.body.classList.remove('no-scroll');
			inner.classList.remove('abShowResultSearchBox__inner--slideUp');
			// Reset scroll position
			document.body.style.position = '';
			document.body.style.top = '';
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
			this.searchBox.html.classList.remove('abSearchBox--extended');
			logEvent(events.unfocusSearch, eventCategories.search);
		}, timeout);
	},

	allowSearchBoxTouchMove () {
		let allow = true;

		if (!this.elems.searchBoxWrapper.classList.contains('abShowResultSearchBox--visible')) {
			allow = false;
		} else if (this.searchBox.html.classList.contains('abSearchBox--show-overlay')) {
			allow = false;
		}

		return allow;
	},

	/**
	 * @param {Number} type
	 * @param {Object} searchBoxData
	 * @param {String} searchBoxData.departDate
	 * @param {String} searchBoxData.from
	 * @param {String} searchBoxData.fromIata
	 * @param {Array} searchBoxData.fromIatas
	 * @param {Boolean} searchBoxData.fromMetro
	 * @param {String} searchBoxData.returnDate
	 * @param {String} searchBoxData.to
	 * @param {String} searchBoxData.toIata
	 * @param {Array} searchBoxData.toIatas
	 * @param {Boolean} searchBoxData.toMetro
	 */
	setHeaderFromToDates (type, searchBoxData) {
		const abFromToDates = gebi('abFromToDates');
		const from = qs('.fromIata');
		const to = qs('.toIata');
		const arrows = qs('.abHeader__fromToDatesArrow');

		if (!searchBoxData?.[0]) {
			return;
		}
		if (type !== 2) {
			const { departDate, returnDate, fromIata, toIata } = searchBoxData[0];

			if (from) {
				from.innerHTML = (this.isAllNumeric(fromIata)) ? this.truncateString(searchBoxData[0].from, 5) : fromIata;
			}

			if (to) {
				to.innerHTML = (this.isAllNumeric(toIata)) ? this.truncateString(searchBoxData[0].to, 5) : toIata + ',';
			}

			const getFormattedDate = (date) => {
				const dateObject = dateParseISO(date);
				const day = dateGetDate(dateObject);
				const monthNumber = dateGetMonth(dateObject);
				const month = js_params.months[monthNumber];
				return `${day} ${month}`;
			};

			let datesString = getFormattedDate(departDate);

			if (type === 1 && returnDate) {
				datesString += ` - ${getFormattedDate(returnDate)}`;
			}

			qs('.dates', abFromToDates).innerHTML = datesString;

			if (arrows) {
				arrows.classList.add(type === 0 ? 'icon-arrow-right' : 'icon-switch');
			}
		} else {
			const fromIata = searchBoxData[0].fromIata;
			const toIata = searchBoxData.slice(-1)[0].toIata;
			const nbLegs = searchBoxData.length;

			if (from) {
				from.innerHTML = (this.isAllNumeric(fromIata)) ? this.truncateString(searchBoxData[0].from, 5) : fromIata;
			}

			if (to) {
				to.innerHTML = (this.isAllNumeric(toIata)) ? this.truncateString(searchBoxData.slice(-1)[0].to, 5) : toIata;
			}

			const icon = 'icon-openjaw-' + nbLegs;

			if (arrows) {
				arrows.classList.add(icon);
			}
		}
	},

	blurAbBtnCards () {
		const viewBtns = qs('.abBtnCard--container');
		const activeBtn = qs('active');

		viewBtns?.classList?.remove?.('active');

		activeBtn?.classList?.remove?.('active');
	},

	generateTempResult (previewGroup) {
		const journeys = [];

		// do not add more results if we already have a lot
		if (!previewGroup || qsa('#results-container > .abResult').length > 15) {
			return;
		}

		let { flights } = previewGroup;
		const { segments, trips } = previewGroup;

		// TODO: get backend to return agents as an array
		flights = flights.map((flight) => {
			flight.agents = [{
				agent: flight.agent.name,
				code: flight.agent.code,
				price: parseInt(flight.agent.minprice),
				stop: 0
			}];
			return flight;
		});


		resultsRender.response.flights = flights;
		resultsRender.response.segments = segments;
		resultsRender.response.trips = trips;

		for (let i = 0; i < flights.length && i < 10; ++i) {
			journeys.push(resultsRender.getFlightRenderData(flights[i], i, false));
		}

		const html = renderJourneys(journeys, { preview: true });

		this.elems.resultsContainer.insertAdjacentHTML('afterbegin', html);
	},

	/**
	 *
	 * @param {number} interval
	 */
	setupPreviewResultsTimeout (interval) {
		this.clearPreviewResultsInterval();

		this.previewResultsInterval = setInterval(() => {
			const [lastHiddenResult] = qsa('.abResult:not(.visible)', this.elems.resultsContainer).slice(-1);
			if (!lastHiddenResult) {
				this.clearPreviewResultsInterval();
				return;
			}
			slideDown(lastHiddenResult);
			lastHiddenResult.classList.add('visible');
			qsa('.abResult.visible', this.elems.resultsContainer).filter((item, index) => index > 6).forEach((element) => {
				element.remove();
			});
		}, interval);
	},

	clearPreviewResultsInterval () {
		clearInterval(this.previewResultsInterval);
	},

	/**
	 *
	 * @param {string} sortBy // price traveltime bestValue
	 */
	setSortingTabs (sortBy) {
		// Dont include landing setup for events
		if (qs('.abTabNav__btn.sort-type.active')) {
			if (sortBy === 'price') {
				logEvent(events.sortCheapest, eventCategories.sort);
			} else if (sortBy === 'traveltime') {
				logEvent(events.sortQuickest, eventCategories.sort);
			} else {	// bestValue
				logEvent(events.sortBest, eventCategories.sort);
			}
		}

		this.elems.sortBars.forEach((btn) => {
			btn.classList.toggle('active', btn.dataset.sort === sortBy);
		});
	},

	renderNoMoreResults () {
		if (qs('#no-more-results', this.elems.resultsContainer)) {
			return;
		}

		const html = `
<div id="no-more-results" class="results-container__footer">
	<div>
		<span>
			<img src="/static/v${js_params.version}/images/global/round-flygresor.png" alt="">
			${l('showresult.noMoreResults')}
		</span>
	</div>
	<span>${l('showresult.noMoreResultsDescription')}</span>
</div>
`;

		this.elems.resultsContainer.insertAdjacentHTML('beforeend', html);
	},

	async offlineFooterButtonEvent () {
		await this.resultsGetNext(true);
		if (!resultsFetcher.isError) {
			gebi('#results-offline')?.remove?.();
		}
	},

	offlineFooterRender () {
		if (qs('#results-offline', this.elems.resultsContainer) || this.searchParams.page === resultsRender?.response?.meta?.numberOfPages) {
			return;
		}

		const html = `
<div id="results-offline" class="results-container__footer results-container__footer--offline" style="display:none">
	<div>
		<span class="header">
			${l('Network error')}
		</span>
	</div>
	<div>
		<span>${l('error.e14')}</span>
	</div>
</div>
		`;

		this.elems.resultsContainer.insertAdjacentHTML('beforeend', html);
	},

	showResetFiltersMsg () {
		const config = {
			messageText: l('showresult.info.allResultsAreFiltered'),
			buttonText: l('showresult.filter.removeBtnText'),
			callBack: () => {
				this.filtersStore.resetAll();
			}
		};

		this.showDisplayMessage(config);
	},

	showNoYouthTicketsWarning () {
		// Boot up no youth ticket warning message to user
		const noYouthTicketWarning = gebi('results-warning');
		// Dynamically set height for closing animation
		noYouthTicketWarning.classList.remove('hidden');
		const resizeMessage = () => {
			noYouthTicketWarning.style.height = noYouthTicketWarning.querySelector('.abDisplayMessage').offsetHeight + 'px';
		};
		resizeMessage();
		window.addEventListener('resize', resizeMessage);
		// Bind close button click event
		const onButtonClick = (event) => {
			event.stopPropagation();
			noYouthTicketWarning.style.height = '0px';
			window.removeEventListener('resize', resizeMessage);
			setTimeout(() => {
				noYouthTicketWarning.parentElement.removeChild(noYouthTicketWarning);
			}, 1000);
		};
		noYouthTicketWarning.querySelector('.abDisplayMessage__btn').addEventListener('click', onButtonClick);

		// Fetch other available ticket matching query
		this.isYouthSearch = false;
		this.filtersStore.set({ key: 'youthTicket', value: null });
	},

	/**
	 * @param {Object} sortingPrices
	 * @param {Number} sortingPrices.cheapest
	 * @param {Number} sortingPrices.fastest
	 * @param {Number} sortingPrices.best
	 * @param {Number} sortingPrices.emission
	 */
	updateSortingTabs () {
		const data = {
			cheapest: {
				price: resultsRender?.response?.sortingButtons?.cheapest,
				traveltime: resultsRender?.response?.meta?.sortingButtonsTravelTime?.cheapest
			},
			fastest: {
				price: resultsRender?.response?.sortingButtons?.fastest,
				traveltime: resultsRender?.response?.meta?.sortingButtonsTravelTime?.fastest
			},
			best: {
				price: resultsRender?.response?.sortingButtons?.best,
				traveltime: resultsRender?.response?.meta?.sortingButtonsTravelTime?.best
			},
			emission: {
				price: resultsRender?.response?.sortingButtons?.emission,
				traveltime: resultsRender?.response?.meta?.sortingButtonsTravelTime?.emission
			}
		};

		// Loop through data and call lc and traveltime functions
		for (const key in data) {
			data[key].price = data[key].price > 0 ? lc(data[key].price) : '';
			data[key].traveltime = data[key].traveltime > 0 ? getTimeText(data[key].traveltime) : '';
		}

		const indexedObject = Object.values(data);

		this.elems.sortBars.forEach((btn, index) => {
			index = index % indexedObject.length;

			if (indexedObject?.[index]?.price) {
				btn.querySelector('.sort-price').innerHTML = indexedObject?.[index].price;
			} else {
				btn.querySelector('.sort-price').innerHTML = l('global.simplePhrases.unavailable');
			}

			const timeButton = qs('.sort-time', btn);
			if (timeButton) {
				timeButton.innerHTML = indexedObject?.[index]?.traveltime;
			}
		});
	},

	/**
	 *
	 * @param {String} str
	 * @returns {Boolean}
	 */
	isAllNumeric: str => str.match(/^[0-9]+$/),

	/**
	 * @param {String} str
	 * @param {Number} num
	 * @returns
	 */
	truncateString: (str, num) => str.length > num ? str.slice(0, num) + '.' : str
};


class MobileFooterController {
	constructor (elems) {
		this.elems = elems;
		this.footerThreshold = 10;
		this.resetScrollState();
		this.bindHandlers();
		this.onResize(); // init sizes & classes
		this.onScroll(); // init footer state
	}

	resetScrollState () {
		this.prevY = 0;
		this.totalDist = 0;
		this.direction = 'down';
		this.sortingFooterVisible = this.isMobile && this.elems.footer.style.bottom === '0px';
	}

	bindHandlers () {
		// cache handlers
		this.rafScroll = this.rafScroll.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.onResize = this.onResize.bind(this);

		window.addEventListener('scroll', this.rafScroll, { passive: true });
		window.addEventListener('resize', () => {
			cancelAnimationFrame(this.resizeRAF);
			this.resizeRAF = requestAnimationFrame(this.onResize);
		});
	}

	rafScroll () {
		if (this.scrollRAF) {
			return;
		}
		this.scrollRAF = requestAnimationFrame(() => {
			this.onScroll();
			this.scrollRAF = null;
		});
	}

	onResize () {
		this.isMobile = isMobileView();
		// cache heights / thresholds
		this.footerHeight = this.elems.footer.offsetHeight;
		this.topButtonThreshold = window.innerHeight * 2;

		// reposition cookie notice if needed
		this.updateCookieNotice();

		// reset scroll tracking so footer doesn’t jump
		this.resetScrollState();
	}

	onScroll () {
		const y = window.pageYOffset;
		const dy = Math.abs(y - this.prevY);
		const newDir = y > this.prevY ? 'down' : 'up';

		if (this.isMobile && !document.body.classList.contains('timeline')) {
			// accumulate distance only if direction stays the same
			this.totalDist = (newDir === this.direction ? this.totalDist + dy : dy);
			this.direction = newDir;

			if ((this.direction === 'up' && this.totalDist > this.footerThreshold) || (this.prevY < 10)) {
				this.showFooter();
			} else if (this.direction === 'down' && this.totalDist > this.footerThreshold) {
				this.hideFooter();
			}

			window.showresult.displayDirector && window.showresult.displayDirector.hideChipMenus();

			// body.scrolled toggle
			document.body.classList.toggle('scrolled', y > 0);

			this.updateCookieNotice();
		}

		// scroll-to-top button
		const btn = this.elems.scrollToTop;
		if (this.direction === 'down' && y > this.topButtonThreshold) {
			btn.classList.add('abScrollToTop--visible');
		} else {
			btn.classList.remove('abScrollToTop--visible');
		}

		this.prevY = y;
	}

	showFooter () {
		this.elems.footer.style.bottom = '';
		this.sortingFooterVisible = true;
	}

	hideFooter () {
		this.elems.footer.style.bottom = `-${this.footerHeight + 10}px`;
		this.sortingFooterVisible = false;
	}

	updateCookieNotice () {
		const notice = window.Main?.cookieNotice?.html;
		if (!notice) {
			return;
		}
		notice.style.bottom = this.sortingFooterVisible
			? `${this.footerHeight}px`
			: '';
	}
}


window.showresult = showresult;

documentReady(function () {
	showresult.init();
});
